<template>
<div>
  <b-card>
      <b-tabs pills card>
        <b-tab title="Reporte Venta Diaria Detallado" active>
        <b-row>    
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Inicial</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaIniRVD"></b-form-input>
            </b-input-group>
            </b-col>
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Final</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaFinRVD"></b-form-input>
            </b-input-group>
            </b-col>
             <b-col md="3"  v-if="mostrarTRVD" >
            <br>
                 <label for="Saldo">Valor Total</label>
                 <b-form-input v-model="this.total"  type="text"  placeholder="Total" disabled></b-form-input>
            </b-col>
            <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="enviarRVD" >Generar</b-button>
            </b-col>
            <b-col md="1">
                <download-excel  v-if="mostrarTRVD"
                    class   = "btn btn-default"
                    :data   ="json_data"
                    :fields ="json_fieldsRVD"
                    name    = "reporteVentaDiariaPorusuario.xls">   
                    <br>                    
                    <b-button variant="link"><i class="fa fa-file-excel-o" aria-hidden="true"></i>Excel</b-button>
                </download-excel>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
              <br>
                <List :mapState="'cafeteriaReports'" v-if="mostrarTRVD"  :showbtn="false" :allDispatch="'controlaccesoreportsaux'" :exportExcel="true" :excelHead="json_fieldsRVD" nameFileExcel="Reporte venta diaria Detallado.xls" ></List>
            </b-col>
        </b-row>
        </b-tab>
        <b-tab title="Reporte venta diaria por producto">
        <b-row>    
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Inicial</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaIniRVDP"></b-form-input>
            </b-input-group>
            </b-col>
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Final</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaFinRVDP"></b-form-input>
            </b-input-group>
            </b-col>
             <b-col md="3"  v-if="mostrarTRVDP" >
            <br>
                 <label for="Saldo">Valor Total</label>
                 <b-form-input v-model="this.total2"  type="text"  placeholder="Total" disabled></b-form-input>
            </b-col>
            <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="enviarRVDP" >Generar</b-button>
            </b-col>
            <b-col md="1">
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <br>
                <List :mapState="'cafeteriaReports'" :exportExcel='true' :excelHead='json_fieldsRVDP' nameFileExcel="reporteVentaDiariaPorProducto.xls" :showbtn="false" v-if="mostrarTRVDP"  :allDispatch="'controlaccesoreportsaux'"></List>
            </b-col>
        </b-row>
        </b-tab>
        <b-tab title="Reporte de Movimientos">
        <b-row>    
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Inicial</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaIniRM"></b-form-input>
            </b-input-group>
            </b-col>
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Final</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaFinRM"></b-form-input>
            </b-input-group>
            </b-col>
            <b-col md="3">
            <br>
                 <label for="nombre">Usuario</label>
                 <b-form-input v-model="idUser"  type="text"  placeholder="Buscar Usuario" text="Buscar" @change="consultar"></b-form-input>
            </b-col>
            <b-col md="3">
            <br>
                 <label for="Saldo">Saldo Actual</label>
                 <b-form-input v-model="SaldoAc"  type="text"  placeholder="Saldo" disabled></b-form-input>
            </b-col>
            <b-col md="9">
              <br>
                 <label for="Numbreu">Nombre usuario</label>
                 <b-form-input v-model="nombreComRM"  type="text"  placeholder="Nombre Usuario" disabled></b-form-input>
            </b-col>            
            <b-col md="1"> 
              <br>     
              <br>          
                <b-button variant="success" @click="enviarRM" >Generar</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <br>
                <List :mapState="'cafeteriaReports'" :showbtn="false" v-if="mostrarTRM" :exportExcel='true' :excelHead='json_fieldsRM' nameFileExcel="Reporte venta por usuario.xls"  :allDispatch="'controlaccesoreportsaux'"></List>
            </b-col>
        </b-row>
        </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>
<script>
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import List from '@/components/modules/base/list.vue'

Vue.component('downloadExcel', JsonExcel)

export default {
 name: 'reportsCafeteriaList', 
 data (){
  return{
  fechaIniRVD:'',
  fechaFinRVD:'',
  fechaIniRVDP:'',
  fechaFinRVDP:'',
  fechaIniRM:'',
  fechaFinRM:'',
  idUser:'',
  IdRM:'',
  SaldoAc:'',
  nombreComRM:'',
  mostrarTRVD:false,
  mostrarTRVDP:false,
  mostrarTRM:false,
  List2:'',
  total:Number,
  total2:Number,
  json_fieldsRVD: {
            'Id Usuario': 'id',
            'Nombres': 'name',
            'Documento': 'num_doc',
            'fecha y hora': 'datetime',
            'Descripcion' :'products',
            'Valor' :'total_sin_formato',
        },
 json_fieldsRVDP: {
            'Categoría': 'nameC',
            'Subcategoría': 'nameS',
            'Producto': 'nameP',
            'Cantidad': 'CANTIDAD',
            'Valor' :'total_sin_formato',
        },
 json_fieldsRM: {
            'Fecha y Hora': 'datetime',
            'Descripcion': 'products',
            'Valor': 'total',
        },
        json_data:'',
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
    }  
  
 },
 components: {
    List
  },
    methods:{
        consultar(){
            let  array={'id':this.idUser}
            this.$store.dispatch('cafeteriaReportsDataUser', array).then(Response=>{
                if( this.$store.getters.cafeteriaReports != null ){
                    this.IdRM= this.$store.getters.cafeteriaReports.id
                    this.nombreComRM= this.$store.getters.cafeteriaReports.name
                    this.SaldoAc= this.$store.getters.cafeteriaReports.saldo
                    
                }else{
                    alert("No Existe Usuario");
                }  
            })
        },
        enviarRVD(){
            let varsum = 0
            this.mostrarTRVD = false
            let  array={'fechaIniRVD':this.fechaIniRVD+' 00:00:00','fechafinRVD':this.fechaFinRVD+' 23:59:00'}
            let mostrarTRVD= ''
            this.$store.dispatch('cafeteriaReportslistRVD', array).then(Response=>{
                if(this.$store.getters.cafeteriaReports.name != ''){
                    this.List= this.$store.getters.cafeteriaReports
                    this.json_data= this.$store.getters.cafeteriaReports.items
                    this.List2= this.$store.getters.cafeteriaReports.items
                    this.total = 0
                    this.List2.forEach(element => {
                        //console.log('El valor total ',element.total)
                        let varsum = element.total.replace(",", "");
                        console.log('El valor sin coma ',varsum)
                        this.total += Number(varsum)
                    });
                    console.log('Suma',varsum);
                    this.mostrarTRVD=true
                }else{
                    this.mostrarTRVD=false
                }
                
            })  
         
        },
        enviarRVDP(){
            this.mostrarTRVDP = false
            let  array={'fechaIniRVDP':this.fechaIniRVDP+' 00:00:00','fechafinRVDP':this.fechaFinRVDP+' 23:59:00'}
            let mostrarTRVDP= ''
            this.$store.dispatch('cafeteriaReportslistRVDP', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    this.json_data= this.$store.getters.cafeteriaReports.items
                    this.List2= this.$store.getters.cafeteriaReports.items
                    this.total2 = 0
                    this.List2.forEach(element => {
                        console.log('El valor total ',element.total)
                        this.total2 += Number(element.total)
                    });
                    console.log('Suma',this.total2);

                    this.mostrarTRVDP=true
                }else{
                    this.mostrarTRVDP=false
                }  
            })
        },
        enviarRM(){
            this.mostrarTRM = false
            let  array={'IdRM':this.IdRM,'fechaIniRM':this.fechaIniRM+' 000:00:00','fechafinRM':this.fechaFinRM+' 23:59:00'}
            let mostrarTRM= ''
            this.$store.dispatch('cafeteriaReportslistRM', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    this.List= this.$store.getters.controlaccesoreports
                    this.json_data= this.$store.getters.cafeteriaReports.items
                    this.mostrarTRM=true
                }else{
                    this.mostrarTRM=false
                }
                
            })  
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/cafeteria/reports/list.vue